import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import FirstFold from "./first-fold/FirstFold";

import Playables from './playables/Playables';
import FeaturesList from './feature-list/feature-list';
import AwardsSection from './awards/awards-section';

import Footer from "./footer-section/Footer";
import SplashUniverse from './splash-universe/content';
import Header from "./header/Header";
import * as S from "./style";
import ScreenTime from './screen-time/ScreenTime';
import Faq from './faq/faq';
import { PARENT_SIGNUP_PATH } from '../../routes/route-paths';
import { PARENT_SIGNIN_PATH } from '../../routes/route-paths';

const Home = () => {

  useEffect(() => {
    typeof trackAnalyticsEvent != "undefined" && trackAnalyticsEvent('Oddbods Landing Page Viewed');
  }, [])

  const btnClickEvent = () => {
    trackAnalyticsEvent('Oddbods Landing Page Interacted', {
      'Clicked on': 'CTA Text',
    });
  }

  var isUserLogin = window.location.href.includes('email');
  var ctaText = isUserLogin? 'Login': 'Sign up for free' ;
  var urlToRedirect = isUserLogin? PARENT_SIGNIN_PATH: PARENT_SIGNUP_PATH ;

  return (
    <S.Wrapper noBackground={true}>
      <BrowserRouter>
        <Header />
        <FirstFold btnClickEvent={btnClickEvent} ctaText={ctaText} urlToRedirect={urlToRedirect} />
        <ScreenTime btnClickEvent={btnClickEvent} ctaText={ctaText} urlToRedirect={urlToRedirect} />
        <SplashUniverse btnClickEvent={btnClickEvent} ctaText={ctaText} urlToRedirect={urlToRedirect} />
        <FeaturesList btnClickEvent={btnClickEvent} ctaText={ctaText} urlToRedirect={urlToRedirect} />
        <Playables btnClickEvent={btnClickEvent} ctaText={ctaText} urlToRedirect={urlToRedirect} />
        <AwardsSection btnClickEvent={btnClickEvent} ctaText={ctaText} urlToRedirect={urlToRedirect} />
        <Faq />
        <Footer />
      </BrowserRouter>
    </S.Wrapper>
  );
};


export default Home;
